// @ts-nocheck
import React, { useEffect, useRef } from "react";

function VendorSignupStepThree({ isStepSix, stepThreeStates }) {
  // Scroll to top handler
  const scrollTopRef = useRef(null);
  useEffect(() => {
    console.log("HELLO FROM THIS COMPONENT");
    scrollTopRef.current.scrollIntoView();
  }, [isStepSix]);

  return (
    <div className="px-10 pt-10" ref={scrollTopRef}>
      <div className="flex justify-between items-center">
        <h2 className="font-semibold text-2xl text-shuttlelaneBlack">
          Create Password
        </h2>

        {/* <button
          disabled
          className="h-5 w-16 disabled:bg-shuttlelaneLightPurple disabled:border-gray-400 disabled:text-gray-400 text-sm flex items-center justify-center border-[.3px] border-shuttlelaneBlack rounded-full p-2"
        >
          Skip
        </button> */}
      </div>

      <p className="text-sm">
        Sign up as a vendor to start driving for Shuttlelane
      </p>

      {/* FORM */}
      <form className="text-shuttlelaneBlack mt-10 flex flex-col gap-y-5">
        {/* Password */}
        <div className="flex flex-col gap-y-1">
          <label htmlFor="password" className="text-sm">
            Password
          </label>
          <input
            type="password"
            name="password"
            value={stepThreeStates?.password}
            onChange={(e) => stepThreeStates?.setPassword(e.target.value)}
            placeholder="********"
            className="w-full h-13 p-3 border-[0.3px] focus:outline-none border-gray-400 rounded-lg"
          />
        </div>
      </form>
    </div>
  );
}

export default VendorSignupStepThree;
